import { render, staticRenderFns } from "./TagRow.vue?vue&type=template&id=7e8c4f7c&scoped=true"
import script from "./TagRow.vue?vue&type=script&lang=js"
export * from "./TagRow.vue?vue&type=script&lang=js"
import style0 from "./TagRow.vue?vue&type=style&index=0&id=7e8c4f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8c4f7c",
  null
  
)

export default component.exports